import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchClientPageAPI } from "../../api"; // Import from api.js

// Async thunk for fetching dashboard data
export const fetchClientPage = createAsyncThunk(
  "clientPage/fetchClientPage",
  async (_, { rejectWithValue }) => {
    try {
      // Use the function from api.js
      const data = await fetchClientPageAPI();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch dashboard data");
    }
  }
);

const clientPageSlice = createSlice({
  name: "clientPage",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientPage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClientPage.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchClientPage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetError } = clientPageSlice.actions;
export default clientPageSlice.reducer;
